import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../assets/page-image/cyds/banner.png';
const _hoisted_1 = {
  class: "cyds-wrapper"
};
const _hoisted_2 = {
  class: "cyds-page"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_5 = {
  key: 1,
  class: "mentor-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "mentor-image"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "mentor-info"
};
const _hoisted_10 = {
  class: "mentor-title"
};
const _hoisted_11 = {
  key: 0,
  class: "mentor-subtitle",
  style: {
    "font-size": "18px"
  }
};
const _hoisted_12 = {
  class: "mentor-content"
};
const _hoisted_13 = {
  key: 0,
  class: "mentor-section"
};
const _hoisted_14 = {
  class: "text",
  style: {
    "font-size": "20px"
  }
};
const _hoisted_15 = {
  key: 1,
  class: "mentor-section"
};
const _hoisted_16 = {
  class: "text"
};
const _hoisted_17 = {
  key: 2,
  class: "empty-wrapper"
};
const _hoisted_18 = {
  key: 3,
  class: "pagination"
};
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getMentorList } from '@/api/mentor';
export default /*@__PURE__*/_defineComponent({
  __name: 'Cyds',
  setup(__props) {
    const router = useRouter();
    // 导师列表
    const mentorList = ref([]);
    // 加载状态
    const loading = ref(true);
    // 分页相关
    const currentPage = ref(1);
    const pageSize = ref(2); // 每页显示2个导师
    const total = ref(0);
    // 计算当前页显示的导师列表
    const displayMentorList = computed(() => {
      const start = (currentPage.value - 1) * pageSize.value;
      const end = start + pageSize.value;
      return mentorList.value.slice(start, end);
    });
    // 获取导师列表
    const fetchMentorList = async () => {
      try {
        loading.value = true;
        const res = await getMentorList();
        if (res.data) {
          mentorList.value = res.data;
          total.value = res.data.length;
        }
      } catch (error) {
        console.error('获取导师列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    // 跳转到详情页
    const goToDetail = id => {
      router.push(`/cyds/${id}`);
    };
    // 分页切换
    const handlePageChange = page => {
      currentPage.value = page;
      // 滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    // 页面加载时获取数据
    onMounted(() => {
      fetchMentorList();
    });
    return (_ctx, _cache) => {
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "创业导师"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SectionTitle, {
        title: "导师信息",
        showMore: false,
        showCard: false
      })]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : displayMentorList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayMentorList.value, mentor => {
        return _openBlock(), _createElementBlock("div", {
          key: mentor.id,
          class: "mentor-card",
          onClick: $event => goToDetail(mentor.id)
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: mentor.url || '../assets/page-image/cyds/daoshi1.png',
          alt: mentor.name
        }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(mentor.name), 1), mentor.organizationTitle ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(mentor.organizationTitle), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [mentor.academicCredentials ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "label"
        }, null, -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(mentor.academicCredentials), 1)])) : _createCommentVNode("", true), mentor.researchInterests ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "label"
        }, null, -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(mentor.researchInterests), 1)])) : _createCommentVNode("", true)])])], 8, _hoisted_6);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无导师数据", -1)]))])), total.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "total, prev, pager, next",
        total: total.value,
        "page-size": pageSize.value,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        onCurrentChange: handlePageChange
      }, null, 8, ["total", "page-size", "current-page"])])) : _createCommentVNode("", true)]), _createVNode(_component_Footer)]);
    };
  }
});